<template>
  <section class="step-by-step w-100 py-5">
    <!-- header -->
    <b-container class="text-center py-5 text-purple">
      <!-- title -->
      <h1 class="mb-4">Passo a Passo</h1>

      <!-- content -->
      <p class="font-weight-light mb-1">Você nunca achou que seria tão fácil vender seu carro.</p>
    </b-container>

    <!-- Infográfico -->
    <b-container class="text-center py-5 text-purple">
      <!-- Passo 1 -->
      <b-row class="mb-5">
        <b-col
          lg="6"
          cols="12"
          class="justify-content-center d-flex align-items-center mb-3"
          data-aos="fade-in-zoom"
          data-aos-once="true"
          data-aos-delay="150"
        >
          <h1
            v-html="'1º'"
            class="mr-2 font-weight-bolder"
          />
          <h5
            class="font-weight-normal text-left"
            v-html="'Agende sua avaliação gratuita, <b>no local e dia de sua preferência.</b>'"
          />
        </b-col>
        
        <b-col
          class="text-center"
          lg="6"
          cols="12"
          data-aos="fade-in-zoom"
          data-aos-once="true"
        >
          <img 
            class="img-fluid"
            width="350"
            :src="require(`@/assets/icons/iso/passo-01.svg`)"
          />
        </b-col>
      </b-row>

      <!-- Passo 2 -->
      <b-row class="my-5">    
        <b-col
          lg="6"
          cols="12"
          class="justify-content-center d-flex align-items-center order-lg-2 mt-5 mb-3"
          data-aos="fade-in-zoom"
          data-aos-once="true"
          data-aos-delay="150"
        >
          <hgroup class="d-flex">
            <h1
              v-html="'2º'"
              class="mr-2 font-weight-bolder"
            />
            <h5
              class="font-weight-normal text-left"
              v-html="'Fazemos a avaliação de seu veículo e publicamos em segundos para milhares de compradores com real interesse em seu carro.'"
            />
          </hgroup>
        </b-col>

        <b-col
          lg="6"
          cols="12"
          class="text-center order-lg-1"
          data-aos="fade-in-zoom"
          data-aos-once="true"
        >
          <img 
            class="img-fluid"
            width="350"
            :src="require(`@/assets/icons/iso/passo-02.svg`)"
          />
        </b-col>
      </b-row>

      <!-- Passo 3 -->
      <b-row class="my-5">    
        <b-col
          lg="6"
          cols="12"
          class="justify-content-center d-flex align-items-center"
          data-aos="fade-in-zoom"
          data-aos-once="true"
          data-aos-delay="150"
        >
          <h1
            v-html="'3º'"
            class="mr-2 font-weight-bolder"
          />
          <h5
            class="font-weight-normal text-left"
            v-html="'<b>Em 40 minutos</b> você recebe centenas de ofertas.'"
          />
        </b-col>
        
        <b-col
          lg="6"
          cols="12"
          class="text-center"
          data-aos="fade-in-zoom"
          data-aos-once="true"
        >
          <img 
            class="img-fluid"
            width="350"
            :src="require(`@/assets/icons/iso/passo-03.svg`)"
          />
        </b-col>
      </b-row> 

      <!-- Passo 4 -->
      <b-row class="mt-5">   
        <b-col
          lg="6"
          cols="12"
          class="justify-content-center d-flex align-items-center order-lg-2 mb-3"
          data-aos="fade-in-zoom"
          data-aos-once="true"
          data-aos-delay="150"
        >
          <h1
            v-html="'4º'"
            class="mr-2 font-weight-bolder"
          />
          <h5
            class="font-weight-normal text-left"
            v-html="'Proposta aceita, você <b>recebe na mesma hora</b> e só depois entrega as chaves.'"
          />
        </b-col>

        <b-col
          lg="6"
          cols="12"
          class="text-center order-lg-1"
          data-aos="fade-in-zoom"
          data-aos-once="true"
        >
          <img 
            class="img-fluid"
            width="350"
            :src="require(`@/assets/icons/iso/passo-04.svg`)"
          />
        </b-col>
      </b-row>
      
    </b-container>
  </section>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init()

export default {
  
}
</script>

<style lang="scss" scoped>
  .step-by-step {
    min-height: 100vh;
  }
</style>
